<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.level1'> {{$t('txt.nivel1')}}: {{this.level1.name}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update nivel1'])">
                <router-link v-if='this.level1' :to="{ name: 'editcategory', params: { id: level1.id }}">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                        <i :class="input_field.icon"></i>
                                        <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                        <i v-bind:class="input_field.icon"></i>
                                        <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import Level1Service from '../../api-services/nivel1.service.js'

export default {
  name: 'viewlevel1',
  data () {
    return {
      level1: null
    }
  },
  methods: {
    getLevel1 () {
      Level1Service.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.level1 = response.data.data
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    },
    showPifLabel (pif) {
      let PIF = parseInt(pif)
      switch (PIF) {
        case 0: return this.$t('placeholder.nuNecesitaPif')
        case 1: return this.$t('placeholder.necesitaPif')
      }
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'order',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.level1) ? this.level1.ord : null,
            icon: 'fas fa-sort-numeric-up'
          },
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            inputValue: (this.level1) ? this.level1.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'pif',
            labelName: this.$t('placeholder.pif'),
            inputValue: (this.level1) ? this.showPifLabel(this.level1.pif) : null,
            icon: 'fas fa-file-signature'
          }
        ],
        column_2: [
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            inputValue: (this.level1) ? this.level1.discount : null,
            icon: 'fas fa-money-bill-wave info-tool'
          },
          {
            inputName: 'addition_min',
            labelName: this.$t('placeholder.addition_min'),
            inputValue: (this.level1) ? this.level1.addition_min : null,
            icon: 'fas fa-percentage'
          },
          {
            inputName: 'addition_distribution',
            labelName: this.$t('placeholder.addition_distribution'),
            inputValue: (this.level1) ? this.level1.addition_distribution : null,
            icon: 'fas fa-percentage'
          },
          {
            inputName: 'addition_partner',
            labelName: this.$t('placeholder.addition_partner'),
            inputValue: (this.level1) ? this.level1.addition_partner : null,
            icon: 'fas fa-percentage'
          },
          {
            inputName: 'addition_retail',
            labelName: this.$t('placeholder.addition_retail'),
            inputValue: (this.level1) ? this.level1.addition_retail : null,
            icon: 'fas fa-percentage'
          }
        ]
      }
    }
  },
  mounted () {
    this.getLevel1()
  }
}
</script>
